import { useState } from 'react';
import { Box } from '@mui/material';

const CYCLE_MS = 2200;

// Shown while IsAuth is pending. Mirrors the static #boot placeholder in index.html (same mark, same timing), so the swap
// from HTML to React is not visible: the L is drawn, then the circle, then it fades, and repeats. pathLength=100 lets the
// dash values be percentages.
const keyframes = {
    '@keyframes appLoadingL': { '0%': { strokeDashoffset: 100 }, '27%, 100%': { strokeDashoffset: 0 } },
    '@keyframes appLoadingRing': { '0%, 27%': { strokeDashoffset: 105 }, '68%, 100%': { strokeDashoffset: 0 } },
    '@keyframes appLoadingFade': { '0%, 86%': { opacity: 1 }, '100%': { opacity: 0 } },
};

export function AppLoading() {
    // Start at the phase the HTML copy has reached (it began at about page start) so the hand-off does not restart.
    const [delay] = useState(() => `-${Math.round(performance.now() % CYCLE_MS)}ms`);
    const anim = (name) => `${name} ${CYCLE_MS}ms ease-in-out ${delay} infinite`;

    return (
        <Box sx={{ position: 'fixed', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Box
                component='svg'
                viewBox='0 0 96 96'
                aria-hidden='true'
                sx={{
                    ...keyframes,
                    width: 96,
                    height: 96,
                    fill: 'none',
                    stroke: 'rgb(250, 231, 181)',
                    strokeDasharray: 100,
                    animation: anim('appLoadingFade'),
                    '& circle': {
                        strokeWidth: 3,
                        strokeLinecap: 'round', // overlaps at the join, so no gap where the circle closes
                        strokeDasharray: '101 200', // long gap: no second dash shows before the circle starts
                        transform: 'rotate(-90deg)',
                        transformOrigin: '48px 48px',
                        animation: anim('appLoadingRing'),
                    },
                    '& path': { strokeWidth: 8, strokeLinejoin: 'miter', animation: anim('appLoadingL') },
                    '@media (prefers-reduced-motion: reduce)': {
                        animation: 'none',
                        '& circle, & path': { animation: 'none', strokeDashoffset: 0 },
                    },
                }}>
                <circle cx='48' cy='48' r='42' pathLength='100' />
                <path d='M37 26V66H63' pathLength='100' />
            </Box>
        </Box>
    );
}
